import actions from './actions';

let initState = {
    purchaseDashboardLoader: false,
    purchaseDashboardDetails: '',
    purchaseDashboardError: ''
};

export default function purchaseDashboardReducer(state = initState, action) {
    switch (action.type) {
        case actions.PURCHASE_DASHBOARD_START: {
            return {
                ...state,
                purchaseDashboardLoader: true
            };
        }
        case actions.PURCHASE_DASHBOARD_SUCCESS: {
            return {
                ...state,
                purchaseDashboardLoader: false,
                purchaseDashboardDetails: action.payload
            };
        }
        case actions.PURCHASE_DASHBOARD_FAILURE: {
            return {
                ...state,
                purchaseDashboardLoader: false,
                purchaseDashboardError: action.payload
            };
        }
        default:
            return state;
    }
}

